// components/received/ConfirmLogoutModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const ConfirmLogoutModal = ({ show, onConfirm, onCancel }) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      className="re-confirm-logout-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Logout</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className='text-white'>
        <p>Are you sure you want to logout?</p>
        <p className="text-muted small">You will need to authenticate again to access your endowments.</p>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmLogoutModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ConfirmLogoutModal;